var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticClass:"box"},[_c('div',{ref:"charts",style:({'height': _vm.parsePixel(_vm.height)})})])
}
var staticRenderFns = []

export { render, staticRenderFns }